import { DataTableConfig } from "../interfaces/dataTable.interface";
import { MappedAttribute } from "app/helpers/components/mappingAttribute/mappingAttribute.component";

export class OutputModel {
    outputCode: string;
    systemCode: string;
    description: string;
    descriptionExt?: string;
    image?: string;
    urlImage?: string;
    creado?: string;
    modificado?: string;
    fechaCreacion?: Date;
    fechaActualizacion?: Date;
    completeness?: any;
    documentState?: number;
    recurrency?: number;
    mappingFrom?: string;
    mappingTo?: string;
    status: string;
    mappingAttribute?: MappingOutputAttribute[];
    rulesIdByCommand?: any;
    destinationMail?: string;
    ccMail?: string;
    delayTaskHour?: number;
    repeatTaskHour?: number;
    recurrencyDays?: number;
    recurrencyWeek?: number;
    daysOfWeek?: string;
    monthDay?: number;
    lastFriday: boolean;
    recurrencyFortnight: boolean;
    recurrencyMonthDay: boolean;
    delayTask: boolean;
    repeatTaskEver: boolean;
    expireTask: boolean;
    startDate?: string;
    timeZone?: number;
    startTime?: string;
    expirationDate?: string;
    expirationTime?: string;
};

export class OutputResultRequest {
    outputCode?: string;
    status?: number;
    startedAt?: Date;
    endedAt?: Date;
    dataTableConfig: DataTableConfig;
}

export interface MappingOutputAttribute extends MappedAttribute {
    valor?: string;
    outputCode?: string;
    systemCode?: string;
    status?: string;
    creado?: string;
    modificado?: string;
    fechaCreacion?: Date;
    fechaActualizacion?: Date;
};

// This model is used for the detail over the output
export class MappingOutputAttributeModel {
    id?: number;
    attribute: string;
    type: string;
    sourceKey: string;
    attributeKey: string;
    rulePrototype: string;
    outputCode?: string;
    systemCode?: string;
};


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/output.classes.ts